

























































































import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class Settings extends Vue {
  @Prop({ default: false }) readonly active!: boolean;
}
